import React, {useContext, useEffect, useState} from "react";
import axios from 'axios'
import {GlobalContext} from "../../contexts/context";

export const useReset = () => {
    const context = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState({});
    let mounted = true;
    const handleUseReset = async (item) => {
        setLoading(true);
        try {
            const data = await axios.get(`${context.applicationState.apiUrl}/api/sendRPAComm.aspx?command=reset&jobID=${item.JobID}&rpaName=${item.rpaName}`, {withCredentials: true});
            if (mounted) {
                if (data.status === 200) {
                    if (data.data.rows) {
                        setContent({
                            data: data.data,
                            message: "RPA Reset Successful",
                            hasError: false
                        });
                    } else {
                        setContent({
                            data: [],
                            message: data.data,
                            hasError: true
                        });
                    }
                } else {
                    setContent({
                        data: [],
                        message: "An unknown error occurred while attempting to reset rpa.",
                        hasError: true
                    })
                }
                setLoading(false)
            }
        } catch(err){
            setContent({
                data: [],
                message: "An unknown error occurred while attempting to reset rpa.",
                hasError: true
            });
            setLoading(false)
        }
    };

    useEffect(() => {
        return () => {
            mounted = false;
        };
    }, []);

    return {loading, content, handleUseReset};
};
